import { create } from "zustand";
import i18n from "../i18n";

const useLayoutStore = create((set) => {
    // provera da li je dark tema već sačuvana u localStorage
    const savedTheme = localStorage.getItem("isDarkTheme");
    const initialDarkTheme = savedTheme ? JSON.parse(savedTheme) : false;

    const savedLanguage = localStorage.getItem("appLanguage");
    const initialLanguage = savedLanguage === "en" || savedLanguage === "sr" ? savedLanguage : "sr";

    return {
        // employees
        employeesCardsInRow: 1,

        calculateEmployeesCardsInRow: () => {
            const width = window.innerWidth;
            let cards = 1;

            if (width < 685) cards = 1;
            else if (width < 969) cards = 2;
            else if (width < 1325) cards = 3;
            else if (width < 1600) cards = 4;
            else if (width < 1874) cards = 5;
            else if (width < 2151) cards = 6;
            else if (width < 2428) cards = 7;
            else cards = 8;

            set({ employeesCardsInRow: cards });
        },

        // devices
        devicesCardsInRow: 1,

        calculateDevicesCardsInRow: () => {
            const width = window.innerWidth;
            let cards = 1;

            if (width < 1138) cards = 1;
            else if (width < 1608) cards = 2;
            else if (width < 2072) cards = 3;
            else cards = 4;

            set({ devicesCardsInRow: cards });
        },

        smallMediumScreen: window.innerWidth < 795,
        smallScreen: window.innerWidth < 684,

        // dropdown max height
        dropdownMaxHeight: 194,
        activeDropdownElement: null,

        setActiveDropdownElement: (element) => {
            set({ activeDropdownElement: element });
        },

        calculateDropdownMaxHeight: () => {
            const state = useLayoutStore.getState();
            if (!state.activeDropdownElement) {
                set({ dropdownMaxHeight: 194 });
                return;
            }

            const dropdownRect = state.activeDropdownElement.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            const spaceBelow = viewportHeight - dropdownRect.bottom;
            const paddingFromBottom = 9; // Par px od dna ekrana

            // MaxHeight je ili CSS max-height (194px) ili prostor do dna minus padding, šta je manje
            const calculatedMaxHeight = Math.min(194, Math.max(100, spaceBelow - paddingFromBottom));
            set({ dropdownMaxHeight: calculatedMaxHeight });
        },

        isTouchDevice:
            "ontouchstart" in window ||
            navigator.maxTouchPoints > 0 ||
            navigator.msMaxTouchPoints > 0,

        // 🔥 učitavanje početne teme iz localStorage-a
        isDarkTheme: initialDarkTheme,

        // 🔥 toggle koji i setuje u localStorage
        toggleTheme: () =>
            set((state) => {
                const newTheme = !state.isDarkTheme;
                localStorage.setItem("isDarkTheme", JSON.stringify(newTheme));
                return { isDarkTheme: newTheme };
            }),

        language: initialLanguage,

        setLanguage: (language) => {
            const nextLanguage = language === "en" ? "en" : "sr";
            localStorage.setItem("appLanguage", nextLanguage);
            i18n.changeLanguage(nextLanguage);
            document.documentElement.lang = nextLanguage;
            set({ language: nextLanguage });
        },
    };
});
// inicijalno izračunavanje
useLayoutStore.getState().calculateEmployeesCardsInRow();
useLayoutStore.getState().calculateDevicesCardsInRow()

// listener na resize
window.addEventListener("resize", () => {
    useLayoutStore.getState().calculateEmployeesCardsInRow();
    useLayoutStore.getState().calculateDevicesCardsInRow();
    useLayoutStore.setState({ smallMediumScreen: window.innerWidth < 795 });
    useLayoutStore.setState({ smallScreen: window.innerWidth < 684 });
    useLayoutStore.getState().calculateDropdownMaxHeight();
});

export default useLayoutStore;
